import styled from '@emotion/styled';

export type Props = {
  direction?: 'row' | 'column';
  gap?: number;
  mainAxisAlignment?:
    | 'start'
    | 'center'
    | 'end'
    | 'space-around'
    | 'space-between'
    | 'space-evenly';
  crossAxisAlignment?: 'start' | 'center' | 'end';
};

export const Flex = styled.div<Props>`
  display: flex;
  flex-direction: ${({ direction }) => direction};
  gap: ${({ gap }) => (gap === undefined ? 'unset' : `${gap}px`)};
  align-items: ${({ crossAxisAlignment }) =>
    crossAxisAlignment === undefined ? 'initial' : crossAxisAlignment};
  justify-content: ${({ mainAxisAlignment }) =>
    mainAxisAlignment === undefined ? 'initial' : mainAxisAlignment};
`;
